var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header-holder"}),_c('Header',{attrs:{"menuItems":_vm.menuItems}}),_c('router-view'),_c('Footer',{staticStyle:{"margin-top":"20px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }